import axios from "axios";
import CryptoJS from 'crypto-js';
import { logOutRedirectCall, showErrorMessage } from "../pages/common/Utils";

let key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_KEY);
let iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_IV);

const showMessage = (msg) => {
  console.log(msg)
}

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // headers : authHeaders()
  headers: {
    'api-key': process.env.REACT_APP_API_KEY,
    'Accept-Language': 'en',
    'Content-Type': 'text/plain',
  }
});

// Body Encryption Request
axiosClient.interceptors.request.use(function (request) {
  request.data = bodyEncryption(request.data, true)
  if (localStorage.getItem("token") !== undefined || localStorage.getItem("token") !== null) {
    request.headers['token'] = bodyEncryption(JSON.stringify(localStorage.getItem("token")), false)
  }
  return request;
});

axiosClient.interceptors.response.use(
  function (response) {
    response = bodyDecryption(response.data);

    let respData = JSON.parse(response);
    if (parseInt(respData.code) === -1) {
      logOutRedirectCall();
      return;
    }
    if (parseInt(response.code) === 0) {
      showMessage(response.data.message)
    }
    response = JSON.parse(response)
    return response;
  },
  function (error) {
    console.log("error : ", error);
    let res = error.response;
    if (error.code && error.code === 'ERR_NETWORK') {
      logOutRedirectCall()
      showErrorMessage(`${error.code}: ${error.message}`);
    }
    if (res.status && parseInt(res.status) === 401) {
      logOutRedirectCall()
    }
    return Promise.reject(error);
  }
); 

function bodyEncryption(request, isStringify) {

  request = (isStringify) ? JSON.stringify(request) : request;
  let encrypted = CryptoJS.AES.encrypt(request, key, { iv: iv });
  return encrypted.toString();
}

function bodyDecryption(request) {
  let decrypted = CryptoJS.AES.decrypt(request.toString(), key, { iv: iv });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

export { axiosClient };